module.exports = __webpack_public_path__ + "media/images/webpage/coupons/pc-cover-19f17b65f07179d475cb81c2bd08e40e.webp";